import React from 'react';
import { Modal } from './Modal';
import type { NFTDetailItem } from '../types';
import './UpgradeModal.css';

export interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  nft: NFTDetailItem | null;
  onConfirm: () => void;
}

const BENEFITS = [
  { title: 'Гранитный статус', icon: '/shield.svg' },
  { title: 'Повышенные призы', icon: '/highprize.svg' },
  { title: 'Финальную торговую фазу', icon: '/faza.svg' },
  { title: 'Оффлайн мероприятие', icon: '/offline.svg' },
];

export const UpgradeModal: React.FC<UpgradeModalProps> = ({
  isOpen,
  onClose,
  nft,
  onConfirm,
}) => {
  if (!nft) return null;

  const currentStep = nft.step ?? nft.tier ?? 1;
  const nextStep = Math.min(currentStep + 1, 15);
  const price = (nft.upgrade_price ?? nft.price ?? 0);

  const formatPrice = (value: number) => {
    if (value >= 1_000_000) {
      return `${(value / 1_000_000).toFixed(value % 1_000_000 === 0 ? 0 : 1).replace(/\.0$/, '')} млн. ₽`;
    }
    if (value >= 1000) {
      return `${Math.round(value / 1000)} тыс. ₽`;
    }
    return `${value.toLocaleString('ru-RU')} ₽`;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title=""
      containerClassName="upgrade-modal-v2-container"
    >
      <div className="upgrade-modal-v2">
        <div className="upgrade-modal-v2-top-block">
          <div className="upgrade-modal-v2-icon-outer">
            <div className="upgrade-modal-v2-icon-wrap">
              <div className="upgrade-modal-v2-icon" aria-hidden />
            </div>
          </div>
          <h2 className="upgrade-modal-v2-title">Разгоните NFT до максимума!</h2>
          <div className="upgrade-modal-v2-steps">
            <span className="upgrade-modal-v2-step upgrade-modal-v2-step-current">
              Шаг {currentStep}
            </span>
            <span className="upgrade-modal-v2-step-arrow">→</span>
            <span className="upgrade-modal-v2-step upgrade-modal-v2-step-next">
              Шаг {nextStep}
            </span>
          </div>
        </div>

        <div className="upgrade-modal-v2-benefits">
          <span className="upgrade-modal-v2-benefits-title">Что вы получите?</span>
          <div className="upgrade-modal-v2-benefits-grid">
            {BENEFITS.map(({ title, icon }, i) => (
              <div
                key={i}
                className="upgrade-modal-v2-benefit-card"
                style={{ backgroundImage: `url('${icon}')` }}
              >
                <span className="upgrade-modal-v2-benefit-text">{title}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="upgrade-modal-v2-price-block">
          <div className="upgrade-modal-v2-price-inner">
            <span className="upgrade-modal-v2-price-value">{formatPrice(price)}</span>
            <span className="upgrade-modal-v2-price-label">Стоимость улучшения</span>
          </div>
        </div>

        <div className="upgrade-modal-v2-actions">
          <button
            className="button--accent button--full"
            onClick={onConfirm}
          >
            Улучшить за {formatPrice(price)}
          </button>
          <button
            className="upgrade-modal-v2-btn upgrade-modal-v2-btn-cancel"
            onClick={onClose}
          >
            Отмена
          </button>
        </div>
      </div>
    </Modal>
  );
};
